import { defineComponent } from 'vue'
import { useScroll } from '@vueuse/core'
import { useStore } from '@gx-vuex'
import NewsDetails from '@/components/NewsDetails'
import ImagePreview from '@/components/ImagePreview'
import SvgIcon from '@/components/svgIcon/index.vue'

import styles from './style.module.less'

export default defineComponent({
  name: 'RightData',
  props: {
    rightData: Array as PropType<NewsItem[]>,
    hasSeria: Boolean as PropType<boolean>,
    rightState: {
      type: Object as PropType<{
        init: boolean;
        loading: boolean;
        hasMore: boolean;
      }>,
      default: () => {
        return {
          init: false,
          loading: false,
          hasMore: true
        }
      }
    },
  },
  emits: [ 'next' ],
  setup(props, { emit }) {

    const store = useStore()
    const scrollEl = ref()

    const { y, arrivedState } = useScroll(scrollEl, {behavior: 'smooth' })

    watch(() => arrivedState.bottom, (val) => {
      if (val) {
        emit('next')
      }
    }, {
      deep: true
    })

    const rightScroll = (top: number) => {
      y.value = top
    }

    const openDetails = (record: NewsItem) => {
      store.global.publicOpenDetails(record, !!record.traceId)
    }

    return () => {
      return (
        <>
          {
            props.rightData?.length > 0 && (
              <div class={'flex-main px-16px py-24px bg-hex-26293f w-380px relative h-673px'}>
                <div class={'text-20px leading-26px text-hex-fff text-font-bold mb-20px'}>
                  {props.hasSeria ? 'Series' : 'Suggested for You'}
                </div>
                <div class={styles.rightDataList} ref={scrollEl}>
                  {
                    props.rightData.map(item => (
                      <div class={styles.rightDataItem} onClick={() => openDetails(item)}>
                        <div class={'flex-main-160 w-160'}>
                          <ImagePreview
                            width={160}
                            height={90}
                            url={item.imageShow}
                            alt={item.newsTitle}
                            record={item}
                          />
                        </div>
                        <div class={'flex-main flex flex-col justify-between'}>
                          <div class={styles.title}>
                            {item.newsTitle}
                          </div>
                          <NewsDetails
                            time={item.publishTime}
                            channelName={item.mainChannel?.channelName}
                            style={{ color: 'rgba(255, 255, 255, 0.8)' }}
                          />
                        </div>
                      </div>
                    ))
                  }
                  {
                    props.rightState.loading
                      ? props.rightState.init && <div class={'flex-center pb-19px'}><SvgIcon class={'w-24px h-24px'} name={'media-loading'} /></div>
                      : props.rightState.hasMore
                        ? null
                        : <div class={styles.rightDataEnd}>
                          End
                        </div>
                  }
                </div>
                {
                  props.rightData.length >= 5 && (
                    <div class={styles.bottomFixed}>
                      {
                        y.value > 10
                          ? (
                            <div class={'cursor-pointer flex items-center gap-10px'} onClick={() => rightScroll(0)}>
                              <SvgIcon class={'w-24px h-24px cursor-pointer'} name={'media-iconTop'} />
                              TOP
                            </div>
                          )
                          : <SvgIcon class={'w-24px h-24px cursor-pointer'} name={'media-iconDown'} onClick={() => rightScroll(1000000)} />
                      }

                    </div>
                  )
                }
              </div>
            )
          }
        </>
      )
    }
  }
})
